import { render, staticRenderFns } from "./rule_manage_list.vue?vue&type=template&id=0d9e5c3b"
import script from "./rule_manage_list.vue?vue&type=script&lang=js"
export * from "./rule_manage_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports